const keys = {
  all: ['insureds'],
  insured: id => [...keys.all, { insuredId: parseInt(id, 10) }],
  insuredOverallStatus: id => [...keys.all, 'overall-status', { insuredId: parseInt(id, 10) }],
  insuredAllRecordQueriesKey: id => [...keys.all, 'records', { insuredId: parseInt(id, 10) }],
  insuredAllRecords: id => [...keys.insuredAllRecordQueriesKey(id), 'all'],
  insuredActiveRecords: id => [...keys.insuredAllRecordQueriesKey(id), 'active'],
  insuredArchivedRecords: id => [...keys.insuredAllRecordQueriesKey(id), 'archived'],
  insuredAllRecordsWithTrashed: id => [...keys.insuredAllRecordQueriesKey(id), 'all-with-trashed'],
  insuredEveryRecord: id => [...keys.insuredAllRecordQueriesKey(id), 'every'],
  insuredEmails: (insuredId, recordId, order) => [...keys.all, 'emails', {
    insuredId: parseInt(insuredId, 10),
    recordId: recordId !== 'all' ? parseInt(recordId, 10) : null,
    order
  }],
  insuredAutomatedEmails: (insuredId, recordId, order) => [...keys.all, 'automated-emails', {
    insuredId: parseInt(insuredId, 10),
    recordId: recordId !== 'all' ? parseInt(recordId, 10) : null,
    order
  }]
};

export default keys;
